import { httpClient } from '@/modules/common/services/http/http-client';
import { IShelfCatalogHomeResponse } from './';

const http = httpClient.withOptions({
  baseURL: `${process.env.VUE_APP_BFF_URL}/products/v2`
});

export function getShelfCatalogHome(): Promise<IShelfCatalogHomeResponse> {
  return http.get(`/shelf/catalog/home`, {
    params: {
      buttonsIncluded: 'variable-income'
    }
  });
}
